import {Pipe, PipeTransform} from '@angular/core';
import {ProductSubType} from '@spa/api';
import {Helper} from '../classes';
import {LanguageService} from "../language.service";

@Pipe({
	name: 'productSubType'
})
export class ProductSubTypePipe implements PipeTransform {

	constructor(private languageService: LanguageService) {
	}

	transform(subType: ProductSubType): string {
		return Helper.textsHelper().getProductSubTypeName(subType, this.languageService.getCurrentLanguage());
	}
}
